// external dependencies
import { ApiResponse, HTTP_API_SUCCESS_STATUS_CODE } from "@swiggy-private/core-utils";

import { HTTP_METHODS, makeDownstreamApiCall, Response } from "@swiggy-private/checkout-core";

// interfaces
export interface Employee {
    firstName: string;
    lastName: string;
    businessEmailId: string;
    businessEmailCommId: string;
}

interface EmailAutoSuggestResponse {
    employees: Employee[];
    status: string;
    statusCode: number;
    responseCode: string;
    message: string;
}

// Endpoint
const ENDPOINT = {
    EMAIL_AUTO_SUGGEST: "/api/v3/billtocompany/email-auto-suggest",
};

// API call function
export async function emailAutoSuggestPublic(
    apiHost: string,
    searchKey: string,
): Promise<ApiResponse<EmailAutoSuggestResponse>> {
    const queryParams = {
        searchKey,
    };

    const response = await makeDownstreamApiCall<Response<EmailAutoSuggestResponse>>({
        apiHost,
        endpoint: ENDPOINT.EMAIL_AUTO_SUGGEST,
        searchParams: queryParams,
        options: { method: HTTP_METHODS.GET },
    });
    if (response.data?.statusCode !== HTTP_API_SUCCESS_STATUS_CODE) {
        throw response;
    } else {
        return response as ApiResponse<EmailAutoSuggestResponse>;
    }
}
